import {
  byteOrder16Items,
  byteOrder32Items,
  byteOrderFloatItems,
  getOptions
} from '@/shared/SelectData'
import { getFormatMessage } from '@/utils/utils'
import { Col, Divider, Form, InputNumber, Radio, Row, Select } from 'antd'
import React from 'react'

export const TemplatePlcAdvanced = () => {
  const formatMessage = getFormatMessage()

  return (
    <div>
      <Divider>
        {formatMessage({ id: 'app.template.plc.edit.advance.package' })}
      </Divider>

      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            label={formatMessage({ id: 'app.template.plc.edit.autoPackage' })}
            name={['advance', 'autoPackage']}
            labelCol={{
              xs: { span: 12 },
              sm: { span: 5 }
            }}
          >
            <Radio.Group>
              <Radio value={0}>
                {formatMessage({
                  id: 'app.template.plc.edit.autoPackage.enable'
                })}
              </Radio>
              <Radio value={1}>
                {formatMessage({
                  id: 'app.template.plc.edit.autoPackage.disable'
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.plcResponceTimeout'
            })}
            name={['advance', 'plcResponceTimeout']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.protocolInterval'
            })}
            name={['advance', 'protocolInterval']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.protocolTimeout1'
            })}
            name={['advance', 'protocolTimeout1']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.protocolTimeout2'
            })}
            name={['advance', 'protocolTimeout2']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.assembleIntervalBitReg'
            })}
            name={['advance', 'assembleIntervalBitReg']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.assembleIntervalWordReg'
            })}
            name={['advance', 'assembleIntervalWordReg']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.maxPacketsBitReg'
            })}
            name={['advance', 'maxPacketsBitReg']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.maxPacketsWordReg'
            })}
            name={['advance', 'maxPacketsWordReg']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>

      <Divider>
        {formatMessage({ id: 'app.template.plc.edit.exceptions' })}
      </Divider>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.errMsgDispTime'
            })}
            name={['advance', 'errMsgDispTime']}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}></Col>
      </Row>

      <Divider>
        {formatMessage({ id: 'app.template.plc.edit.byteOrder' })}
      </Divider>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.byteOrder16'
            })}
            name={['advance', 'byteOrder16']}
          >
            <Select>{getOptions(byteOrder16Items)}</Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.byteOrder32'
            })}
            name={['advance', 'byteOrder32']}
          >
            <Select>{getOptions(byteOrder32Items)}</Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={formatMessage({
              id: 'app.template.plc.edit.byteOrderFloat'
            })}
            name={['advance', 'byteOrderFloat']}
          >
            <Select>{getOptions(byteOrderFloatItems)}</Select>
          </Form.Item>
        </Col>
        <Col span={12}></Col>
      </Row>
    </div>
  )
}
